import { useContext } from 'react';
import { ConfigContext } from '../providers/ConfigContext';
import useMakeApiRequest from './useMakeApiRequest';

const useLookupCaSchoolsApi = () => {
    const { apiBase } = useContext(ConfigContext);
    const makeGetRequest = useMakeApiRequest('GET');

    const lookupCaSchools = async (postalCode: string) => {
        return await makeGetRequest(`${apiBase}/lookup/ca/orgs?postalCode=${encodeURIComponent(postalCode)}`, {});
    };

    return [lookupCaSchools];
};

export default useLookupCaSchoolsApi;
